<template>
  <div>
    <el-dialog :width="Diawidth" :visible.sync="dataListDialogVisible" v-dialogDrag :before-close="handleClose"
      :close-on-click-modal="true" :show-close="true" :close-on-press-escape="true">
      <span slot='title' class="el-dialog__title">{{ title }}</span>
      <!-- <el-input class="mhSearch" placeholder="请输入内容" v-model="input" clearable @input="searchInput"></el-input> -->
      <el-table :data="tableData" :row-class-name="rowIndex" stripe style="width: 100%;" height="530" empty-text="无数据"
        :default-sort="{prop: 'ydbName', order: 'descending'}" @row-dblclick="dbClick">
        <el-table-column :formatter="order" label="序号" width="60"></el-table-column>
        <el-table-column prop="ydbName" label="坝名" width="120"></el-table-column>
        <el-table-column prop="ydbSfwggb" label="类型" sortable width="80"></el-table-column>
        <el-table-column prop="ydbBaZhi" label="坝址" sortable width="300"></el-table-column>
        <el-table-column prop="ydbJcnd" label="建成年月" sortable width="110"></el-table-column>
        <el-table-column prop="ydbSnzc" label="枢纽组成" sortable width="200"></el-table-column>
        <el-table-column prop="ydbSszl" label="所在流域" sortable width="110"></el-table-column>
        <el-table-column prop="ydbKzmj" label="控制面积(k㎡)" width="130"></el-table-column>
        <el-table-column prop="ydbZkr" label="总库容(万m³)" width="120"></el-table-column>
        <el-table-column prop="ydbSjyjkr" label="设计淤积库容(万m³)" width="170"></el-table-column>
        <el-table-column prop="ydbYykr" label="已淤积库容(万m³)" width="160"></el-table-column>
        <el-table-column prop="ydbDhkr" label="滞洪库容(万m³)" width="140"></el-table-column>
      </el-table>

      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[15, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
  import {
    selectYdbInfo,
    ydbjbxxsearch
  } from "@/api/api.js";
  export default {
    data() {
      return {
        dataListDialogVisible: true,
        Diawidth: "91%",
        currentPage: 1,
        pageSize: 15,
        tableData: [],
        totalNum: 0,
        input: '',
        title: ''
      }
    },
    props: ["regionCode", 'regionType','type'],
    mounted() {
      this.dataList();
    },
    methods: {
      dbClick(row) {
        let params = {
          ydbCode: row.ydbCode
        };
        ydbjbxxsearch(params).then((res) => {
          this.$emit("queryDatas", res.data);
          this.$store.commit('queryData', res.data); //token
          this.cancel();
        });
      },

      dataList() {
        let params = {
          pageSize: this.pageSize,
          pageNum: this.currentPage,
        };
        if('yjzx'== this.type){
          params['isYjzx'] = 1;
          this.title = '淤地坝详情';
        }else if('xxb'== this.type){
          params['isXxb'] = 1;
          this.title = '小型坝详情';
        }
        if('0' ==this.regionType){
          params['ydbShengCode'] = this.regionCode;
        }else if('1' ==this.regionType){
          params['ydbShiCode'] = this.regionCode;
        }else if('2' ==this.regionType){
          params['ydbXianCode'] = this.regionCode;          
        }
        selectYdbInfo(params).then((res) => {
          // console.log(res)
          this.totalNum = res.total;
          this.tableData = res.data;
        });
      },

      searchInput(value) {
        let params;
        if (value != '') {
          if (this.$store.state.ydbryorssShow == false) {
            params = {
              ydbName: value,
              ydbCode: this.ClickName[0].code,
              generalField: this.ClickName[0].sectionName,
              pageNum: this.currentPage,
              pageSize: this.pageSize
            };
          } else {
            params = {
              ydbName: value,
              ydbCode: this.ClickName[0].code,
              generalField: this.ClickName[0].sectionName,
              pageNum: this.currentPage,
              pageSize: this.pageSize,
              ydbCodeList: this.$store.state.myydbData.split(',')
            };
          }
        } else {
          if (this.$store.state.ydbryorssShow == false) {
            params = {
              ydbCode: this.ClickName[0].code,
              generalField: this.ClickName[0].sectionName,
              pageNum: this.currentPage,
              pageSize: this.pageSize
            };
          } else {
            params = {
              ydbCode: this.ClickName[0].code,
              generalField: this.ClickName[0].sectionName,
              pageNum: this.currentPage,
              pageSize: this.pageSize,
              ydbCodeList: this.$store.state.myydbData.split(',')
            };
          }
        }
        this.ydbInfoForRegionFun(params);
      },

      handleClose() {
      this.dataListDialogVisible= false;
        this.$emit("getDatalistcancel", {
          dataListDialogVisible: this.dataListDialogVisible
        });
      
    },

      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageSize = val;
        this.dataList();
      },

      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.currentPage = val;
        this.dataList();
      },

      rowIndex({
        row,
        rowIndex
      }) {
        row.rowIndex = rowIndex;
      },

      order(row) {
        return this.pageSize * (this.currentPage - 1) + row.rowIndex + 1;
      }
    }
  }
</script>

<style scoped>
  >>>.el-dialog {
    height: 700px;
    /* background: url(../../../common/images/dialog.png) no-repeat center; */
    background-size: 100% 100%;
  }

  >>>.el-dialog__body {
    height: 560px;
    padding-top: 0;
  }

  >>>.el-dialog__header {
    /* border: none; */
    padding-left: 0;
    margin: 10px 20px 8px 20px;
  }

  >>>.el-dialog__body, .el-dialog__footer{
      /* background: transparent; */
  }

  .mhSearch {
    position: absolute;
    top: 0;
    right: 80px;
    width: 200px;
    margin-top: 18px;
    transform: translate(-50%);
  }

  >>>.el-input__inner {
    height: 25px;
    line-height: 25px;
  }

  >>>.el-input__suffix {
    height: 25px;
    line-height: 25px;
  }

  >>>.el-input__icon {
    height: 25px;
    line-height: 25px;
  }

  >>>.el-table {
    margin-top: 10px;
    /* border-color: #0077AA; */
    /* background-color: transparent !important; */
  }

  >>>.el-table thead {
    /* background-color: rgba(0, 179, 254, 0.5) !important; */
  }

  >>>.el-table .cell {
    text-align: center;
    font-size: 16px;
    color: #000;
  }

  >>>.el-table th {
    background-color: transparent !important;
    border-color: #0077AA;
  }

  >>>.el-table tr {
    background-color: transparent !important;
  }

  >>>.el-table td,
  >>>.el-table th.is-leaf {
    border-color: #0077AA;
  }

  >>>.el-table__body tr:hover>td {
    background-color: rgba(0, 179, 254, 0.3) !important;
  }

  >>>.el-table--border::after,
  >>>.el-table--group::after,
  >>>.el-table::before {
    background-color: #0077AA;
  }

  >>>.el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: rgba(0, 179, 254, 0.1);
  }

  >>>.el-pagination {
    margin-top: 4px;
    text-align: center;
    color: #000;
  }

  >>>.el-pagination__total {
    color: #000;
  }

  >>>.el-pagination__jump {
    color: #000;
  }

  >>>.el-input__inner {
    background: transparent;
    color: #000;
  }

  >>>.el-pager li {
    background: transparent;
    border: 0.5px solid #000;
    padding: 0;
    margin: 0 4px;
  }

  >>>.el-pager li.btn-quicknext,
  .el-pager li.btn-quickprev {
    color: #000;
  }

  >>>.el-pager .more::before {
    color: #000;
  }

  >>>.el-pagination .btn-prev {
    background: transparent;
    color: #000;
  }

  >>>.el-pagination .btn-next {
    background: transparent;
    color: #000;
  }

  >>>.el-pager li.active+li {
    border-left: 1px solid #000 !important;
  }
</style>
